import React, { useState } from 'react';

const SortingProduct = ({ handleSorting }) => {
    const [selectedOption, setSelectedOption] = useState('');

    const handleChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedOption(selectedValue);
        handleSorting(selectedValue);
    };

    return (
        <div>
            {/* <label htmlFor="sorting">Sort by:</label> */}
            <select id="sorting" value={selectedOption} onChange={handleChange}>
                <option value="">Sort by Popularity</option>
                <option value="">Sort by Average Rating</option>
                <option value="priceAsc">Sort by Latest</option>
                <option value="priceDesc">Sort by Price: Low to High</option>
                <option value="priceDesc">Sort by Price: High to Low</option>
            </select>
        </div>
    );
}

export default SortingProduct